/**
 * Created by ${ D K Rai} on 5/28/2018.
 */

import React, {Component} from 'react';
import * as AppConstant from '../common/AppConstant';
import InvalidAccessOrLogin from '../errorsPage/InvalidAccessOrLogin';
import Errors from '../common/Errors';
import {Redirect} from 'react-router-dom';
import {Link} from "react-router-dom";
import SimpleReactValidator from 'simple-react-validator';
import Select from 'react-select';
import * as Util from '../common/Util';
import RequiredAstrisk from '../common/RequiredAstrisk'

class UpdateStaff extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirectToErrorPage:false,
            redirectToForbiddenPage: false,
            redirectToNotFoundPage: false,
            selectedStaffId: '',
            roleList: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER', 'ROLE_VIEW_PAYMENT'],
            selectedRoles:[],
            staff: {
                userRoles: [],
                isOwner: false,
                loginEnabled: true
            },
            loggedInUser:{},
            canChangePasswordField: true,
            disabledButton: false,
            redirectToDashBoard:false,
            apiStatus: {
                isError: false,
                message: '',
                messages: []
            },
            redirectPage: false,
            showLoader:false,
            currentUserData:{
                fullName: null,
                jwtToken:'',
                roles:[]
            }
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleMultiSelectChange = this.handleMultiSelectChange.bind(this);
        this.checkBoxChange = this.checkBoxChange.bind(this);
        this.onChangeLoginEnabled = this.onChangeLoginEnabled.bind(this);
        this.fetchLoggedInStaff = this.fetchLoggedInStaff.bind(this)
        this.fetchStaffDetails = this.fetchStaffDetails.bind(this)
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            element: false
        });
    }

    componentDidMount() {
        this.fetchLoggedInStaff();
    }
    fetchLoggedInStaff(){
        let _this = this;
        fetch(this.props.api + '/staff/currentUser', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    _this.props.onLogoutClick(json.message);
                }else{
                    if(json && json.staff && json.staff.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER"))){
                        _this.setState({loggedInUser: json.staff}, function(){
                            _this.fetchStaffDetails();
                        })
                    }else{
                        this.setState({redirectToErrorPage:true})
                    }
                }
                _this.setState({showLoader:false});
            }).catch(error => {
            console.log(error)
        });
    }

    fetchStaffDetails(){
        console.log("id== " + this.props.tid);
        if (this.props.tid && AppConstant.validateValue(this.props.tid.id, "S") === true) {
            const {apiStatus}  = this.state;
            this.setState({selectedStaffId: this.props.tid.id, showLoader: true});
            fetch(this.props.api + '/staff/' + this.props.tid.id, {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken
                }
            })
                .then(response => response.json())
                .then(json => {
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    } else if (json.message === "User not found" && json.isError === true) {
                        this.setState({showLoader: false, redirectToNotFoundPage: true});
                    } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                        this.setState({showLoader: false, redirectToForbiddenPage: true});
                    } else {
                        if (json.isError === true) {
                            Util.errorResponse(apiStatus, json);
                        } else {
                            const staff = json.staff
                            staff["password"] = "********";
                            staff["confirm"] = "********";
                            delete staff["accountLocked"];
                            delete staff["credentialsExpired"];
                            delete staff["passwordExpiryDate"];
                            delete staff["status"];
                            delete staff["emailSecondary"];
                            delete staff["workPhone"];
                            delete staff["cellPhone"];
                            this.setState({staff: staff, canChangePasswordField: json.canChangePasswordField});
                            let rolesMapped = [];
                            if (json.staff && json.staff.userRoles) {
                                for (var i = 0, l = json.staff.userRoles.length; i < l; i++) {
                                    rolesMapped.push({value: json.staff.userRoles[i], label: json.staff.userRoles[i]});
                                }
                                this.setState({selectedRoles: rolesMapped});
                            }
                        }
                    }
                    this.setState({showLoader:false})
                }).catch(error => {
                this.setState({showLoader:false});
                console.log(error);
            });
        }
    }

    checkBoxChange() {
        const {staff} = this.state;
        if (staff.isOwner === true) {
            staff.isOwner = false;
            this.setState({staff: staff});
        } else {
            staff.isOwner = true;
            this.setState({staff: staff});
        }
    }

    onChangeLoginEnabled() {
        const {staff} = this.state;
        if (staff.loginEnabled === true) {
            staff.loginEnabled = false;
            this.setState({staff: staff});
        } else {
            staff.loginEnabled = true;
            this.setState({staff: staff});
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        const {apiStatus}  = this.state;
        console.log(this.validator.getErrorMessages());
        if (this.validator.allValid()) {
            var url = '/staff/' + this.state.selectedStaffId;
            if (this.props.tid && this.props.tid !== undefined) {
                this.setState({showLoader: true, disabledButton: true});
                fetch(this.props.api + url, {
                    method: 'PUT',
                    mode: 'cors',

                    body: JSON.stringify(this.state.staff),
                    headers: {
                        'X-AUTH-TOKEN': this.props.jwtToken,
                        'content-type': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(json => {
                        if (json && json.isError === false) {
                            Util.successResponse(apiStatus, json);
                            this.setState({disabledButton: false, apiStatus: apiStatus, redirectToDashBoard:(apiStatus.isError === false ? true : false)});
                            if(json.fullName && json.jwtToken){
                                localStorage.clear();
                                const {currentUserData} = this.state;
                                currentUserData.fullName = json.fullName;
                                currentUserData.jwtToken = json.jwtToken;
                                currentUserData.roles = json.roles;
                                this.setState({currentUserData:currentUserData});
                                this.props.onSetAuthentication(this.state.currentUserData);
                            }

                        } else {
                            Util.errorResponse(apiStatus, json);
                            this.setState({disabledButton: false, apiStatus: apiStatus});
                            if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                                this.props.onLogoutClick(json.message);
                            } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                                this.setState({showLoader: false, redirectToForbiddenPage: true});
                            }
                        }
                        this.setState({showLoader: false, disabledButton: false});
                    })
                    .catch(error => {
                        Util.errorCatchResponse(apiStatus, error);
                        this.setState({showLoader: false, disabledButton: false, apiStatus: apiStatus});
                    });
            }
            else if ((this.props.tid === "" || this.props.tid === undefined)) {
                this.setState({showLoader: true, disabledButton: true})
                fetch(this.props.api + '/staff', {
                    method: 'POST',
                    mode: 'cors',
                    body: JSON.stringify(this.state.staff),
                    headers: {
                        'X-AUTH-TOKEN': this.props.jwtToken,
                        'content-type': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(json => {
                        if (json && json.isError === false) {
                            this.setState({
                                redirectPage: true
                            });
                            Util.successResponse(apiStatus, json);
                        } else {
                            Util.errorResponse(apiStatus, json);
                            if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                                this.props.onLogoutClick(json.message);
                            } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                                this.setState({showLoader: false, redirectToForbiddenPage: true});
                            }
                        }
                        this.setState({showLoader: false, disabledButton: false, apiStatus: apiStatus});
                    })
                    .catch(error => {
                        Util.errorCatchResponse(apiStatus, error);
                        this.setState({showLoader: false, disabledButton: false, apiStatus: apiStatus});
                    });
            }
        }else{
            this.validator.showMessages();
            this.forceUpdate();
        }

    }

    handleChange(event) {
        const {staff} = this.state;
        const target = event.target;
        const name = target.name;
        const value = target.value;
        staff[name] = value;
        console.log(name + " === " + value + " ===  ");
        if (name === "emailPrimary" && !this.props.tid) {
            staff["username"] = value
        }
        this.setState({staff: staff});
    }

    handleMultiSelectChange(event) {
        const {staff} = this.state;
        console.log(event);
        let usersForSubmit = [];
        if(event){
            this.setState({selectedRoles: event});
            for (var i = 0, l = event.length; i < l; i++) {
                usersForSubmit.push(event[i].value);
            }
            staff["userRoles"] = usersForSubmit;
            console.log(usersForSubmit);
        }else{
            staff["userRoles"] = usersForSubmit;
        }
        this.setState({staff: staff});
    }

    render() {
        let _this = this;
        var htmlTr = [];
        for (var i = 0, l = _this.state.roleList.length; i < l; i++) {
            var cntains = validateValue(_this.state.roleList[i]);
            if (cntains === false)
                htmlTr.push({value: _this.state.roleList[i], label: _this.state.roleList[i]});
        }

        function validateValue(role){
            var cntains = _this.state.selectedRoles.some(v => {
                return (v.value === role)
            });
            return cntains
        }

        if(this.state.redirectPage){
            return <Redirect to = '/staff/list'/>
        }

        return (
            <div className="wrapper animated fadeInRight">
                <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                      redirectToErrorPage={this.state.redirectToErrorPage}
                                      redirectToNotFoundPage={this.state.redirectToNotFoundPage}
                                      redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                {
                    (this.state.redirectToDashBoard && this.state.apiStatus && this.state.apiStatus.message) ? (<Redirect to={'/staff/list/'+this.state.apiStatus.message}/>) : null
                }
                <div className="row">
                    <div className="col-lg-12">
                        <div className="dashboard-table-wrap">
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">
                                    {_this.props.msg('staff.label.header')}

                                </p>

                            </div>
                            <div className="table-box table-responsive p-m" style={{minHeight:'490px'}}>
                                <p>
                                    Update the fields for this user or reset their password. To disable the user set the [User Enabled] field to uncheck.
                                    <br/>
                                </p>
                                <div style={{'textAlign':'center'}}>
                                <Errors errorObject={this.state.apiStatus}/>
                                </div>
                                <form onSubmit={this.handleSubmit} className="form-horizontal">
                                    <div className="col-md-12">
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('staff.label.firstName')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="text" className="form-control"
                                                           onChange={this.handleChange}
                                                           id="firstName" name="firstName"
                                                           value={this.state.staff.firstName?this.state.staff.firstName:''}/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('first name', this.state.staff.firstName, 'required|min:1|max:30')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('staff.label.lastName')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="text" className="form-control" id="lastName"
                                                           name="lastName" onChange={this.handleChange}
                                                           value={this.state.staff.lastName?this.state.staff.lastName:''}/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('last name', this.state.staff.lastName, 'required|min:1|max:30')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('staff.label.primaryEmail')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="text" className="form-control" id="emailPrimary"
                                                           onChange={this.handleChange}
                                                           name="emailPrimary"
                                                           value={this.state.staff.emailPrimary?this.state.staff.emailPrimary:''}/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('email', this.state.staff.emailPrimary, 'required|email')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('staff.label.isOwner')}</label>

                                                <div className="col-lg-1">
                                                    <input type="checkbox"
                                                           id="isOwner" name="isOwner"
                                                           checked={this.state.staff.isOwner}
                                                           onChange={this.checkBoxChange}/>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('staff.label.loginEnabled')}</label>

                                                <div className="col-lg-1">
                                                    <input type="checkbox"
                                                           id="loginEnabled" name="loginEnabled"
                                                           checked={this.state.staff.loginEnabled} onChange={this.onChangeLoginEnabled} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign:'left'}}>{_this.props.msg('staff.label.userName')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="text" className="form-control" id="username"
                                                           onChange={this.handleChange}
                                                           name="username" autoComplete="new-username"
                                                           value={this.state.staff.username?this.state.staff.username:''}/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('username', this.state.staff.username, 'required|max:255')}
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.canChangePasswordField === true ?
                                                <div>
                                                    <div className="form-group row">
                                                        <label className="col-lg-4 control-label"
                                                               style={{textAlign: 'left'}}>{_this.props.msg('staff.label.password')}<RequiredAstrisk/></label>

                                                        <div className="col-lg-7">
                                                            <input type="password" className="form-control"
                                                                   id="password"
                                                                   onChange={this.handleChange}
                                                                   name="password" autoComplete="new-password"
                                                                   value={this.state.staff.password ? this.state.staff.password : ''}/>
                                                            <div style={{color: "red"}}>
                                                                {this.validator.message('password', this.state.staff.password, 'required|max:255')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    < div className="form-group row">
                                                        <label className="col-lg-4 control-label"
                                                               style={{textAlign: 'left'}}>{_this.props.msg('staff.label.confirm')}<RequiredAstrisk/></label>

                                                        <div className="col-lg-7">
                                                            <input type="password" className="form-control" id="confirm"
                                                                   onChange={this.handleChange}
                                                                   name="confirm" autoComplete="new-confirm"
                                                                   value={this.state.staff.confirm ? this.state.staff.confirm : ''}/>
                                                            <div style={{color: "red"}}>
                                                                {this.validator.message('confirm password', this.state.staff.confirm,
                                                                    `required|in:${this.state.staff.password}`, {messages: {in: 'Passwords need to match!'}})}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div> : <div>
                                                    <div className="form-group row">
                                                        <label className="col-lg-4 control-label"
                                                               style={{textAlign: 'left'}}>{_this.props.msg('staff.label.password')}<RequiredAstrisk/></label>

                                                        <div className="col-lg-7">
                                                            <input type="password" className="form-control"
                                                                   id="password"
                                                                   onChange={this.handleChange}
                                                                   name="password" autoComplete="new-password"
                                                                   value={this.state.staff.password ? this.state.staff.password : ''} readOnly/>
                                                            <div style={{color: "red"}}>
                                                                {this.validator.message('password', this.state.staff.password, 'required|max:255')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    < div className="form-group row">
                                                        <label className="col-lg-4 control-label"
                                                               style={{textAlign: 'left'}}>{_this.props.msg('staff.label.confirm')}<RequiredAstrisk/></label>

                                                        <div className="col-lg-7">
                                                            <input type="password" className="form-control" id="confirm"
                                                                   onChange={this.handleChange}
                                                                   name="confirm" autoComplete="new-confirm"
                                                                   value={this.state.staff.confirm ? this.state.staff.confirm : ''} readOnly/>
                                                            <div style={{color: "red"}}>
                                                                {this.validator.message('confirm password', this.state.staff.confirm,
                                                                    `required|in:${this.state.staff.password}`, {messages: {in: 'Passwords need to match!'}})}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign: 'left'}}>{_this.props.msg('staff.label.roles')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <Select
                                                        isMulti
                                                        name="userRoles"
                                                        options={htmlTr}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        onChange={this.handleMultiSelectChange}
                                                        placeholder="Select Roles"
                                                        closeMenuOnSelect={false}
                                                        value={this.state.selectedRoles}
                                                    />
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('userRoles', this.state.staff.userRoles, 'required')}
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-lg-offset-2 col-lg-10">
                                            <Link to="/staff/list" className="btn btn-white" style = {{marginLeft: '18px'}}>{_this.props.msg('form.label.cancelButton')}</Link>&nbsp;&nbsp;&nbsp;
                                            <input className="btn btn-primary" type="submit" value={_this.props.msg('form.label.submit')}
                                                   disabled={this.state.disabledButton===true}/>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default UpdateStaff;


// WEBPACK FOOTER //
// ./src/components/security/UpdateStaff.js